import { takeLatest } from 'redux-saga/effects';
import { GET_QUESTIONS_DECISION_TREE_START } from 'redux/actions/types';
import { getQuestionsSaga } from './decision-tree-saga';
import {
  getFirstQuestionsSaga,
  getNextQuestionsSaga,
  getPreviousQuestionsSaga,
} from './decision-tree-logic-saga';
import {
  FINISH_DECISION_TREE,
  GET_FIRST_DECISION_TREE_STEP,
  GET_NEXT_DECISION_TREE_STEP,
  GET_PREVIOUS_DECISION_TREE_STEP,
  GET_QUESTIONS_DECISION_TREE_SUCCESS,
  IS_CHECK_UP_AVAILABLE_FOR_CURRENT_DIAGNOSIS_TREE,
} from 'redux/actions/types';
import { finishDTSaga } from './finish-decision-tree-saga';
import {
  analyzeDTResponseSaga,
  consultCheckUpForCurrentDiagnosisTree,
} from './decision-tree-receiver-saga';

export default function* decisionTreeSagas() {
  yield takeLatest(GET_QUESTIONS_DECISION_TREE_START, getQuestionsSaga);
  yield takeLatest(GET_FIRST_DECISION_TREE_STEP, getFirstQuestionsSaga);
  yield takeLatest(GET_NEXT_DECISION_TREE_STEP, getNextQuestionsSaga);
  yield takeLatest(GET_PREVIOUS_DECISION_TREE_STEP, getPreviousQuestionsSaga);
  yield takeLatest(GET_QUESTIONS_DECISION_TREE_SUCCESS, analyzeDTResponseSaga);
  yield takeLatest(FINISH_DECISION_TREE, finishDTSaga);
  yield takeLatest(
    IS_CHECK_UP_AVAILABLE_FOR_CURRENT_DIAGNOSIS_TREE,
    consultCheckUpForCurrentDiagnosisTree,
  );
}
